export default __webpack_public_path__ + "static/media/Agencias de fomento.b5dfde71.png";